var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card',{attrs:{"title":"报备信息"}},[_c('qx-detail-box',{attrs:{"data":_vm.listInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }